"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import Rectangle from "./rectangle";
import { getDisplayName } from "./utils";
import Vector from "../../util/vector";
const CropElement = (props) => {
  return /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx(Rectangle, { width: 5e3, height: props.y, fill: "#000", opacity: 0.2 }),
    /* @__PURE__ */ jsx("g", { transform: `translate(0,${props.y})`, children: /* @__PURE__ */ jsx(Rectangle, { width: props.x, height: 3e3, fill: "#000", opacity: 0.2 }) }),
    /* @__PURE__ */ jsx("g", { transform: `translate(${props.x + props.width},${props.y})`, children: /* @__PURE__ */ jsx(Rectangle, { width: 3e3, height: 3e3, fill: "#000", opacity: 0.2 }) }),
    /* @__PURE__ */ jsx("g", { transform: `translate(${props.x},${props.y + props.height})`, children: /* @__PURE__ */ jsx(
      Rectangle,
      {
        width: props.width,
        height: 4e3 - props.height,
        fill: "#000",
        opacity: 0.2
      }
    ) }),
    /* @__PURE__ */ jsx("g", { transform: `translate(${props.x},${props.y})`, children: /* @__PURE__ */ jsx(
      Rectangle,
      {
        width: props.width,
        height: props.height,
        cursor: props.annotating ? "move" : "default",
        stroke: props.selected ? "#aaa" : "#ddd",
        strokeWidth: props.annotating && props.cropping ? 2 : 0
      }
    ) })
  ] });
};
CropElement.calculateDragPoints = function(x, y, width, height) {
  return [
    { x, y },
    { x: x + width, y },
    { x: x + width, y: y + height },
    { x, y: y + height }
  ].map(Vector.fromObject);
};
CropElement.typeID = "Crop";
CropElement.displayName = getDisplayName(CropElement);
CropElement.getBoundingBox = function(dragPoints) {
  const multipliers = [
    [-1, -1],
    [1, -1],
    [1, 1],
    [-1, 1]
  ];
  return dragPoints.map((point, idx) => {
    return [point.x + multipliers[idx][0], point.y + multipliers[idx][1]];
  });
};
export default CropElement;
